import { ChangeDetectionStrategy, Component, inject, computed } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { Sidebar } from '../../shared/layout/sidebar/sidebar';
import { Header } from '../../shared/layout/header/header';
import { ContentLoadingComponent } from '../../shared/ui/loading/content-loading.component';
import { ConservatoreNotAcceptedDialogComponent } from '../../shared/ui/conservatore-not-accepted-dialog/conservatore-not-accepted-dialog.component';
import { AuthService } from '../../core/service/auth.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-dashboard-layout',
  imports: [
    RouterOutlet,
    Header,
    Sidebar,
    ContentLoadingComponent,
    ConservatoreNotAcceptedDialogComponent,
  ],
  templateUrl: './dashboard-layout.html',
  styleUrl: './dashboard-layout.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardLayout {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  readonly isAdmin = this.authService.isAdmin;

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => (e as NavigationEnd).urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  readonly isSidebarHidden = computed(() => {
    const url = this.currentUrl();
    if (url.startsWith('/contract-signature')) {
      return true;
    }

    const isCommunications = url.startsWith('/communications');
    const isOrgContext = url.includes('orgContext=true');

    return (
      this.isAdmin() &&
      (url === '/home' ||
        url === '/' ||
        (isCommunications && !isOrgContext) ||
        url === '/conservatori')
    );
  });
}
